import { useState, useEffect } from "react";

function useYAxisTitle(periodo) {
  const [yAxisTitleLeft, setYAxisTitleLeft] = useState("");
  const [yAxisTitleRight, setYAxisTitleRight] = useState("");

  useEffect(() => {
    switch (periodo) {
      case "S":
        setYAxisTitleLeft("Turno");
        setYAxisTitleRight("Semana");
        break;
      case "M":
        setYAxisTitleLeft("Día");
        setYAxisTitleRight("Mes");
        break;
      case "A":
        setYAxisTitleLeft("Mes");
        setYAxisTitleRight("Año");
        break;
      default:
        setYAxisTitleLeft("");
        setYAxisTitleRight("");
    }
  }, [periodo]);

  return [yAxisTitleLeft, yAxisTitleRight];
}

export default useYAxisTitle;
